import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import {TableLazyLoadEvent} from 'primeng/table';
import {AuthService} from "../../../../shared/services/auth/auth.service";
import {CallService} from "../../../../shared/services/call/call.service";

@Component({
  selector: 'app-core-last-calls-canvas',
  templateUrl: './sidebar-last-calls.component.html',
  styleUrl: './sidebar-last-calls.component.scss',
})
export class SidebarLastCallsCanvasComponent implements OnChanges, OnInit {
  @Output() saveEmitter = new EventEmitter();
  @Output() open = new EventEmitter();
  @Output() closed = new EventEmitter();
  @Output() choose = new EventEmitter();
  @Input() position: 'left' | 'right' | 'top' | 'bottom' = 'right'; // Sidebar pozisyonu
  @Input() width: string = '30%'; // Sidebar genişliği, varsayılan %40
  isOpen: boolean = false;
  searchTerm: string;

  items: any[] = [];

  totalRecords = 0;

  @Input() lastCalls: any[] = [];

  constructor(
    private readonly callsService: CallService,
    private readonly cdr: ChangeDetectorRef,
    private readonly authService: AuthService
  ) {
  }

  async loadData(event: TableLazyLoadEvent, filter: object) {
    this.totalRecords = 0;
    this.lastCalls = [];
    this.callsService.getFilter(event, filter).subscribe((data: any) => {
      this.lastCalls = data.items;
      this.totalRecords = this.items.length;
    });
  }

  openPopup() {
    this.isOpen = true;
  }

  ngOnInit() {
    this.loadMe();
  }

  loadMe() {
    this.loadData({}, {'filter.getAll': true, 'filter.user.id': this.authService.getUserId(), 'limit': -5});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['width'] && changes['width']?.firstChange === false) {
      this.width = changes['width']?.currentValue;
      this.isOpen = false;
      setTimeout(() => {
        this.isOpen = true;
      }, 200);
      this.cdr.detectChanges();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth <= 480) {
      this.width = '90vw'; // Small screen width
    }
  }

  closePopup() {
    this.isOpen = false;
    this.closed.emit();
  }

  save() {
    this.choose.emit();
  }

  openCallCard(item: any) {
    this.open.emit(item);
  }

  openCall(item: any) {
    this.callsService.callHeaderFunctionWithData$.next(item);

  }
}
